import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxHeight: 16,
  viewboxWidth: 16,
};

export default ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => (
  <SVGLoader
    viewboxHeight={viewboxHeight}
    viewboxWidth={viewboxWidth}
    {...rest}
  >
    <path
      d="M8.5 10.6667C9.29511 10.6649 10.0571 10.3483 10.6194 9.78604C11.1816 9.22381 11.4982 8.46177 11.5 7.66667V3C11.5 2.20435 11.1839 1.44129 10.6213 0.87868C10.0587 0.316071 9.29565 0 8.5 0C7.70435 0 6.94129 0.316071 6.37868 0.87868C5.81607 1.44129 5.5 2.20435 5.5 3V7.66667C5.50176 8.46177 5.8184 9.22381 6.38062 9.78604C6.94285 10.3483 7.70489 10.6649 8.5 10.6667Z"
      fill="currentColor"
    />
    <path
      d="M13.1667 5.3335C12.9899 5.3335 12.8204 5.40373 12.6953 5.52876C12.5703 5.65378 12.5001 5.82335 12.5001 6.00016V7.66683C12.5001 8.7277 12.0787 9.74511 11.3285 10.4953C10.5784 11.2454 9.56095 11.6668 8.50008 11.6668C7.43922 11.6668 6.4218 11.2454 5.67165 10.4953C4.92151 9.74511 4.50008 8.7277 4.50008 7.66683V6.00016C4.50008 5.82335 4.42984 5.65378 4.30482 5.52876C4.1798 5.40373 4.01023 5.3335 3.83341 5.3335C3.6566 5.3335 3.48703 5.40373 3.36201 5.52876C3.23699 5.65378 3.16675 5.82335 3.16675 6.00016V7.66683C3.16642 8.94176 3.62282 10.1746 4.45324 11.142C5.28366 12.1094 6.43315 12.7473 7.69342 12.9402C7.73173 12.9464 7.76668 12.9657 7.79224 12.9949C7.8178 13.0242 7.83236 13.0614 7.83342 13.1002V15.3335C7.83342 15.5103 7.90365 15.6799 8.02868 15.8049C8.1537 15.9299 8.32327 16.0002 8.50008 16.0002C8.67689 16.0002 8.84646 15.9299 8.97149 15.8049C9.09651 15.6799 9.16675 15.5103 9.16675 15.3335V13.1002C9.1678 13.0614 9.18237 13.0242 9.20792 12.9949C9.23348 12.9657 9.26843 12.9464 9.30675 12.9402C10.567 12.7473 11.7165 12.1094 12.5469 11.142C13.3773 10.1746 13.8337 8.94176 13.8334 7.66683V6.00016C13.8334 5.82335 13.7632 5.65378 13.6382 5.52876C13.5131 5.40373 13.3436 5.3335 13.1667 5.3335Z"
      fill="currentColor"
    />
  </SVGLoader>
);
